import type { SegmentView } from './segmentCards';
import styles from './SegmentPanels.module.css';

interface SegmentPanelsProps {
    segments: SegmentView[];
}

/** Assinantes pagos e Gratuitas: DAU, WAU, MAU e Ausentes de cada recorte. */
export function SegmentPanels({ segments }: SegmentPanelsProps) {
    return (
        <div className={styles.stack}>
            {segments.map((s) => (
                <section key={s.id} className={styles.card} aria-labelledby={`segment-${s.id}`}>
                    <header className={styles.header}>
                        <h4 id={`segment-${s.id}`} className={styles.title}>
                            {s.title}
                        </h4>
                        <span className={styles.base}>{s.baseLabel}</span>
                    </header>
                    <div className={styles.grid}>
                        {s.metrics.map((m) => (
                            <article key={m.id} className={styles.metric}>
                                <h5 className={styles.label}>{m.label}</h5>
                                <p className={styles.value}>{m.value}</p>
                                <p className={styles.caption}>{m.caption}</p>
                            </article>
                        ))}
                    </div>
                </section>
            ))}
        </div>
    );
}
